import { apiConstants } from '../constants/apiConstants'

const initialState = {
  baseFolder: '/',
  shareePath: '',
  userPermission: 7,
  user: {},
  folderList: {
    total: 0,
    results: [],
  },
  files: {},
  fileList: {},
  limit: apiConstants.Limit,
  pageNo: apiConstants.PageNo,
  sortBy: apiConstants.SortBy,
  sortType: apiConstants.SortType,
  startDate: 0,
  endDate: 0,
  sharedUserList: {},
  filesToUpload: [],
  sharedFolderDetails: {},
  selectedFolderToSearch: {},
  activeMenu: 'home',
}
export default initialState
